import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import LanguageDropdown from "components/CommonForBoth/TopbarDropdown/LanguageDropdown"
import { applyDocumentLanguage } from "utils/i18nDocument"
import "./deleteAccountPublic.scss"

const APP_STEPS = [
  "Open the mobile app and sign in to your account.",
  "Go to Profile or Account Settings.",
  "Select Delete Account, then confirm the request.",
]

const AppDeleteAccount = () => {
  const { t, i18n } = useTranslation()
  const lang = i18n.language === "sa" ? "sa" : "en"
  const isRtl = lang === "sa"

  document.title = t("Account Deletion")

  useEffect(() => {
    const current = localStorage.getItem("I18N_LANGUAGE") || i18n.language || "en"
    if (i18n.language !== current) {
      i18n.changeLanguage(current)
    }
    applyDocumentLanguage(current)
  }, [i18n, i18n.language])

  return (
    <div className="delete-account-public" dir={isRtl ? "rtl" : "ltr"}>
      <div className="delete-account-public__bg" aria-hidden="true" />

      <header className="delete-account-public__header">
        <LanguageDropdown />
      </header>

      <main className="delete-account-public__main">
        <section className="delete-account-public__hero">
          <span className="delete-account-public__eyebrow">
            {t("How to delete your account")}
          </span>
          <h1>{t("Account Deletion")}</h1>
          <p>
            {t(
              "You can request deletion of your account and associated personal data at any time."
            )}
          </p>
        </section>

        <article className="delete-account-public__card delete-account-public__card--featured">
          <div className="delete-account-public__card-head">
            <span className="delete-account-public__icon" aria-hidden="true">
              <i className="bx bx-mobile-alt" />
            </span>
            <div>
              <span className="delete-account-public__badge">{t("Recommended")}</span>
              <h2>{t("Delete from the app")}</h2>
            </div>
          </div>
          <ol className="delete-account-public__steps">
            {APP_STEPS.map((step, index) => (
              <li key={step}>
                <span className="delete-account-public__step-num">{index + 1}</span>
                <span>{t(step)}</span>
              </li>
            ))}
          </ol>
        </article>

        <div className="delete-account-public__grid">
          <article className="delete-account-public__card">
            <div className="delete-account-public__card-head">
              <span className="delete-account-public__icon" aria-hidden="true">
                <i className="bx bx-envelope" />
              </span>
              <h2>{t("Request deletion by email")}</h2>
            </div>
            <p>
              {t(
                "If you cannot access the app, email support with the subject Account Deletion Request and include the phone number or email registered on your account."
              )}
            </p>
            <div className="delete-account-public__chip">
              <span>{t("Email subject")}</span>
              <strong>{t("Account Deletion Request")}</strong>
            </div>
          </article>

          <article className="delete-account-public__card">
            <div className="delete-account-public__card-head">
              <span className="delete-account-public__icon" aria-hidden="true">
                <i className="bx bx-shield-quarter" />
              </span>
              <h2>{t("Data deletion policy")}</h2>
            </div>
            <p>
              {t(
                "After we verify your identity, we delete or anonymize personal data linked to your account. Some records may be retained where required by law, accounting, or fraud prevention."
              )}
            </p>
          </article>
        </div>
      </main>
    </div>
  )
}

export default AppDeleteAccount
